import React, { useEffect, useState } from "react";
import {
  theme,
  Layout,
  Typography,
  Steps,
  Menu,
  Form,
  Button,
  Space,
  Spin,
  Flex,
  message,
  Result,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GenerateQuestionFields from "../../components/questionnaire/GenerateQuestionFields";
import companyService from "../../services/companyService";
import questionnaireService from "../../services/questionnaireService";
import Collapse from "../../components/collapse/Collapse";
import { ReactComponent as Book } from "../../assets/questionnaire/book.svg";
import { ReactComponent as Message } from "../../assets/questionnaire/message-text.svg";
import ScoreCard from "../../components/questionnaire/score-card/ScoreCard";
import { DomainsContext } from "../../contexts/DomainsContext";
const { Content, Sider } = Layout;

const questionnaireName = {
  genai: "Gen AI",
};

const Questionnaire = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();
  const { search } = useLocation();
  const { companyId, readinessIndexType } = useParams();

  // const params = new URLSearchParams(search)
  // const domIndex = Number.parseInt(params.get('domain'))-1
  // const dimIndex = Number.parseInt(params.get('dimension'))-1

  const [isInitialRender, setIsInitialRender] = useState(true);

  const [companyData, setCompanyData] = useState({});
  const [domainsData, setDomainsData] = useState([]);
  const [currentDomain, setCurrentDomain] = useState({});
  const [currentDimensionsData, setCurrentDimensionsData] = useState([]);
  const [currentDimension, setCurrentDimension] = useState({});
  const [questions, setQuestions] = useState([]);
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [scores, setScores] = useState([]);
  const [dimensionScoreId, setDimensionScoreId] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);
  const [doneDimensionIds, setDoneDimensionIds] = useState([]);

  const [tabsLoading, setTabsLoading] = useState(true);
  const [questionsLoading, setQuestionsLoading] = useState(true);
  const [companyLoading, setCompanyLoading] = useState(true);

  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  const [error, setError] = useState(false);
  const [questionsError, setQuestionsError] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();

  const updateDimension = ({ domain, dimensionIndex }) => {
    const currentDimensionsData = domain.dimensions.map(({ id, title }) => ({
      id,
      title,
    }));

    setCurrentDimensionsData(currentDimensionsData);
    setCurrentDimension({
      dimensionId: currentDimensionsData[dimensionIndex].id,
      dimensionIndex,
    });
  };

  const displayResponses = (questionsData) => {
    try {
      const domId = currentDomain.domainId;
      const dimId = currentDimension.dimensionId;

      const domainResponses = scores.find((obj) => obj.domainId === domId);
      const dimensionResponses = domainResponses?.dimensionScores.find(
        (obj) => obj.dimensionId === dimId,
      );

      if (dimensionResponses) {
        setIsUpdate(true);

        setDimensionScoreId(dimensionResponses.id);

        const initialValues = {};
        const responses = dimensionResponses?.responses.map((item) => {
          const { normalizeScore, response, question: questionData } = item;
          const { type, id, question, checkboxes, maxScore, description } =
            questionData;
          if (type === "list") {
            response.split("$").forEach((item, index) => {
              initialValues[`list-${id}-${index}`] = item;
            });
          }
          initialValues[id] =
            type === "checkbox"
              ? response
                ? response.split("$")
                : []
              : type === "binary"
                ? response === "true"
                : type === "text"
                  ? response
                  : null;

          return {
            id,
            question,
            type,
            answer: response,
            checkboxes,
            maxScore,
            normalizedScore: normalizeScore,
            description,
          };
        });
        setQuestions(responses);
        form.setFieldsValue(initialValues);
      } else {
        setIsUpdate(false);
        setDimensionScoreId(null);
        setQuestions(questionsData);
      }
    } catch (error) {
      console.log(error);
      setIsUpdate(false);
      setQuestions(questionsData);
    }
  };

  const fetchResponses = () => {
    questionnaireService
      .viewResponses(companyId, readinessIndexType)
      .then((response) => {
        const data = response?.data ?? response;
        setScores(data);

        const dimIds = [];
        data?.forEach(({ dimensionScores }) => {
          dimensionScores?.forEach(({ dimensionId }) => {
            dimIds.push(dimensionId);
          });
        });
        setDoneDimensionIds(dimIds);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //this useEffect hook skips initial render and runs when currentDimension changes
  useEffect(() => {
    if (!isInitialRender) {
      setQuestionsLoading(true);
      const fetchDimension = () =>
        questionnaireService.getDimensionById(currentDimension.dimensionId);

      const handleSuccess = (response) => {
        // Check if response is undefined and retry
        if (response === undefined) {
          console.log("Response is undefined, retrying...");
          return fetchDimension().then(handleSuccess).catch(handleError);
        }

        console.log(response, "working");
        const data = response?.data ?? response;
        const questionsData = data?.questions || [];

        //check if its the last dimension of the last domain
        if (
          currentDomain.domainIndex === domainsData.length - 1 &&
          currentDimension.dimensionIndex === currentDimensionsData.length - 1
        ) {
          console.log("hello world! i will show submit button");
          setShowSubmitButton(true);
        } else {
          setShowSubmitButton(false);
        }

        if (questionsData.length === 0) {
          setQuestionsError(false);
          setIsUpdate(false);
          setDimensionScoreId(null);
          form.resetFields();
          setQuestions([]);
          return;
        }

        displayResponses(questionsData);
      };

      const handleError = (error) => {
        console.log(error);
        setQuestionsError(true);
      };

      fetchDimension()
        .then(handleSuccess)
        .catch((error) => {
          const status = error?.response?.status;
          if (status === 500) {
            console.log("getDimensionById 500, retrying once");
            return fetchDimension().then(handleSuccess).catch(handleError);
          }
          handleError(error);
        })
        .finally(() => setQuestionsLoading(false));
    }
  }, [isInitialRender, currentDimension]);

  //this useEffect runs only once
  useEffect(() => {
    companyService
      .getCompanyById(companyId)
      .then((response) => {
        setCompanyData(response.data);

        //these are domain and dimension IDs
        const { currentDomain, currentDimension } =
          response.data.evaluationDetails[readinessIndexType];

        questionnaireService
          .getDomains(readinessIndexType)
          .then((qResponse) => {
            const domainsData = qResponse.data.map(
              ({ id, title, dimensions }) => ({ id, title, dimensions }),
            );
            setDomainsData(domainsData);

            const domIndex =
              currentDomain !== 0
                ? domainsData.findIndex((obj) => obj.id === currentDomain)
                : currentDomain;
            const dimIndex =
              currentDimension !== 0
                ? domainsData[domIndex].dimensions.findIndex(
                    (obj) => obj.id === currentDimension,
                  )
                : currentDimension;

            setCurrentStep(domIndex);
            setCurrentDomain({
              domainId: domainsData[domIndex].id,
              domainIndex: domIndex,
            });

            updateDimension({
              domain: domainsData[domIndex],
              dimensionIndex: dimIndex,
            });

            setIsInitialRender(false);
          })
          .catch((error) => {
            console.log(error);
            setError(true);
          })
          .finally(() => setTabsLoading(false));
      })
      .catch((error) => console.log(error))
      .finally(() => setCompanyLoading(false));

    fetchResponses();
  }, [companyId]);

  const handleNext = () => {
    const currentDimIndex = currentDimension.dimensionIndex;
    if (currentDimIndex < currentDimensionsData.length - 1) {
      setCurrentDimension({
        dimensionId: currentDimensionsData[currentDimIndex + 1].id,
        dimensionIndex: currentDimIndex + 1,
      });
      // console.log('dimension changed', `dimension ind: ${currentDimIndex+1}`)
    } else if (currentDimIndex === currentDimensionsData.length - 1) {
      const currentDomIndex = currentDomain.domainIndex;
      if (currentDomIndex < domainsData.length - 1) {
        setCurrentDomain({
          domainId: domainsData[currentDomIndex + 1].id,
          domainIndex: currentDomIndex + 1,
        });
        setCurrentStep(currentDomIndex + 1);

        updateDimension({
          domain: domainsData[currentDomIndex + 1],
          dimensionIndex: 0,
        });

        // console.log('domain changed', `domain ind: ${currentDomIndex+1}`)
      }
    }

    //check if currently its on second last questions page
    //so that we can change the button from 'Save & Next' to 'Submit' on the last page
    // if(currentDomain.domainIndex === domainsData.length-1 && currentDimIndex === currentDimensionsData.length-2) {
    //   console.log('hello world! i will show submit button')
    //   setShowSubmitButton(true)
    // }
  };

  const handlePrevious = () => {
    const currentDimIndex = currentDimension.dimensionIndex;
    if (currentDimIndex > 0) {
      setCurrentDimension({
        dimensionId: currentDimensionsData[currentDimIndex - 1].id,
        dimensionIndex: currentDimIndex - 1,
      });
    } else if (currentDimension.dimensionIndex === 0) {
      const currentDomIndex = currentDomain.domainIndex;
      if (currentDomIndex > 0) {
        setCurrentDomain({
          domainId: domainsData[currentDomIndex - 1].id,
          domainIndex: currentDomIndex - 1,
        });
        setCurrentStep(currentDomIndex - 1);

        updateDimension({
          domain: domainsData[currentDomIndex - 1],
          dimensionIndex:
            domainsData[currentDomIndex - 1].dimensions.length - 1,
        });
      }
    }
  };

  const getNextPage = () => {
    if (currentDimension.dimensionIndex < currentDimensionsData.length - 1) {
      return {
        dimension:
          currentDimensionsData[currentDimension.dimensionIndex + 1].id,
        domain: currentDomain.domainId,
      };
    } else if (currentDomain.domainIndex < domainsData.length - 1) {
      return {
        dimension: domainsData[currentDomain.domainIndex + 1].dimensions[0].id,
        domain: domainsData[currentDomain.domainIndex + 1].id,
      };
    } else {
      return {
        dimension: 0,
        domain: 0,
      };
    }
  };

  const checkScore = ({ type, maxScore, value, listValue, checkboxes }) => {
    switch (type) {
      case "binary":
        return value ? maxScore : 0;

      case "checkbox":
        if (Array.isArray(checkboxes) && checkboxes.length > 0) {
          const selected = Array.isArray(value) ? value[0] : value;
          if (!selected) return 0;
          const match = checkboxes.find(({ option }) => option === selected);
          return match ? Number(match.marks) || 0 : 0;
        }
        return Array.isArray(value) ? value.length : value ? 1 : 0;

      case "list":
        return listValue.length > 0 ? 1 : 0;

      case "text":
        return value ? maxScore : 0;
    }
  };

  const createResponses = (questions, values) => {
    return questions.map(({ id, maxScore, type, checkboxes }) => {
      let listValue = [];
      if (type === "list") {
        Object.keys(values).forEach((item) => {
          if (item.startsWith(`list-${id}-`) && values[item]) {
            listValue.push(values[item]);
          }
        });
        values[id] = listValue;
      } else if (type === "text") {
        if (!values[id]) values[id] = "";
      } else if (type === "checkbox") {
        if (!values[id]) values[id] = [];
        else if (typeof values[id] === "string") values[id] = [values[id]];
      }

      return {
        questionId: id,
        response:
          type === "binary" || type === "text"
            ? values[id]
            : values[id].join("$"),
        maxScore,
        obtScore: checkScore({
          type,
          maxScore,
          value: values[id],
          listValue,
          checkboxes,
        }),
        type,
      };
    });
  };

  const sendQuestionsResponse = (values) => {
    console.log(values);

    const responses = createResponses(questions, values);

    const dataToSend = {
      companyId,
      currentDomain: getNextPage().domain,
      currentDimension: getNextPage().dimension,
      dimensionId: currentDimension.dimensionId,
      domainId: currentDomain.domainId,
      responses,
      index: readinessIndexType,
    };

    messageApi.open({
      type: "loading",
      key: "questions-response",
      content: "Sending...",
      duration: 0,
    });
    setDisableSaveBtn(true);

    const sendRequest = () => questionnaireService.sendResponse(dataToSend);

    const handleSuccess = (response) => {
      // Check if response is undefined and retry
      if (response === undefined) {
        console.log("Response is undefined, retrying...");
        return sendRequest().then(handleSuccess).catch(handleError);
      }

      console.log(response, "working res");
      console.log(response.data);
      messageApi.open({
        type: "success",
        key: "questions-response",
        content: "Response successfully sent!",
      });
      fetchResponses();
      handleNext();
    };

    const handleError = (error) => {
      console.log(error);
      messageApi.open({
        type: "error",
        key: "questions-response",
        content: "Error sending responses! Please resend.",
      });
      // setCurrentDimension({ dimensionId: currentDimension.dimensionId, dimensionIndex: currentDimension.dimensionIndex })
      // setCurrentDomain({ domainId: currentDomain.domainId, domainIndex: currentDomain.domainIndex })
    };

    sendRequest()
      .then(handleSuccess)
      .catch(handleError)
      .finally(() => setDisableSaveBtn(false));
  };

  const updateQuestionsResponse = (values) => {
    console.log(values);

    const responses = createResponses(questions, values);

    const dataToSend = {
      companyId,
      dimensionId: currentDimension.dimensionId,
      domainId: currentDomain.domainId,
      dimensionScoreId,
      responses,
    };

    messageApi.open({
      type: "loading",
      key: "questions-response",
      content: "Updating...",
      duration: 0,
    });
    setDisableSaveBtn(true);
    questionnaireService
      .updateResponses(dataToSend)
      .then((response) => {
        console.log(response);
        messageApi.open({
          type: "success",
          key: "questions-response",
          content: "Response successfully updated!",
        });
        fetchResponses();
      })
      .catch((error) => {
        console.log(error);
        messageApi.open({
          type: "error",
          key: "questions-response",
          content: "Error updating responses! Please resend.",
        });
      })
      .finally(() => setDisableSaveBtn(false));
  };

  const submitQuestionnaire = (values) => {
    console.log(values);

    const responses = createResponses(questions, values);

    const dataToSend = {
      companyId,
      currentDomain: getNextPage().domain,
      currentDimension: getNextPage().dimension,
      dimensionId: currentDimension.dimensionId,
      domainId: currentDomain.domainId,
      responses,
      index: readinessIndexType,
    };

    messageApi.open({
      type: "loading",
      key: "submit-response",
      content: "Sending...",
      duration: 0,
    });
    setDisableSaveBtn(true);

    const sendResponseRequest = () =>
      questionnaireService.sendResponse(dataToSend);
    const submitQuestionnaireRequest = () =>
      questionnaireService.submitQuestionnaire({
        companyId,
        index: readinessIndexType,
      });

    const handleSubmitSuccess = (submitResponse) => {
      // Check if response is undefined and retry
      if (submitResponse === undefined) {
        console.log("Submit response is undefined, retrying...");
        return submitQuestionnaireRequest()
          .then(handleSubmitSuccess)
          .catch(handleSubmitError);
      }

      // Check for successful status (200-299 range)
      const status = submitResponse?.status || submitResponse?.response?.status;
      if (status && (status < 200 || status >= 300)) {
        console.log(`Submit response status ${status} is not successful`);
        throw new Error(`Unsuccessful status: ${status}`);
      }

      console.log(submitResponse);
      console.log(submitResponse.data);

      messageApi.open({
        type: "success",
        key: "submit-response",
        content: "Response successfully submitted!",
      });
      messageApi.open({
        type: "loading",
        content: "Redirecting...",
        duration: 0,
      });
      setTimeout(() => {
        navigate("/companies");
      }, 2000);
    };

    const handleSubmitError = (error) => {
      console.log(error);
      const status = error?.response?.status;

      if (status === 500) {
        console.log("submitQuestionnaire 500, retrying once");
        return submitQuestionnaireRequest()
          .then(handleSubmitSuccess)
          .catch((retryError) => {
            console.log(retryError);
            setShowSubmitButton(true);
            messageApi.open({
              type: "error",
              key: "submit-response",
              content: "Error submitting questionnaire! Please try again.",
            });
          });
      }

      setShowSubmitButton(true);
      messageApi.open({
        type: "error",
        key: "submit-response",
        content: "Error submitting questionnaire! Please try again.",
      });
    };

    const handleSendResponseSuccess = (response) => {
      // Check if response is undefined and retry
      if (response === undefined) {
        console.log("Send response is undefined, retrying...");
        return sendResponseRequest()
          .then(handleSendResponseSuccess)
          .catch(handleSendResponseError);
      }

      // Check for successful status (200-299 range)
      const status = response?.status || response?.response?.status;
      if (status && (status < 200 || status >= 300)) {
        console.log(`Send response status ${status} is not successful`);
        throw new Error(`Unsuccessful status: ${status}`);
      }

      console.log(response);
      console.log(response.data);

      // Proceed to submit questionnaire
      submitQuestionnaireRequest()
        .then(handleSubmitSuccess)
        .catch(handleSubmitError)
        .finally(() => setDisableSaveBtn(false));
    };

    const handleSendResponseError = (error) => {
      console.log(error);
      const status = error?.response?.status;

      if (status === 500) {
        console.log("sendResponse 500, retrying once");
        return sendResponseRequest()
          .then(handleSendResponseSuccess)
          .catch((retryError) => {
            console.log(retryError);
            setShowSubmitButton(true);
            messageApi.open({
              type: "error",
              key: "submit-response",
              content: "Error sending responses! Please resend.",
            });
            setDisableSaveBtn(false);
          });
      }

      setShowSubmitButton(true);
      messageApi.open({
        type: "error",
        key: "submit-response",
        content: "Error sending responses! Please resend.",
      });
      setDisableSaveBtn(false);
    };

    sendResponseRequest()
      .then(handleSendResponseSuccess)
      .catch(handleSendResponseError);
  };

  return (
    <>
      {contextHolder}
      <Layout
        style={{
          minHeight: "100vh",
          minWidth: "1800px",
          boxSizing: "border-box",
        }}
      >
        <Header bgColor={colorBgContainer} />
        <Content
          style={{
            padding: "0 40px",
          }}
        >
          <Flex
            justify='space-between'
            style={{
              padding: 35,
              borderRadius: 15,
              backgroundColor: "#FFF",
              color: "#07224D",
              fontWeight: 700,
              marginTop: 35,
            }}
          >
            <div
              style={{
                fontSize: 25,
              }}
            >
              Questionnaire - {questionnaireName[readinessIndexType]}
            </div>
            <div
              style={{
                fontSize: 20,
              }}
            >
              {!companyLoading ? (
                companyData?.companyName &&
                `Company: ${companyData.companyName}`
              ) : (
                <div style={{ width: "150px", textAlign: "center" }}>
                  <Spin indicator={<LoadingOutlined spin />} />
                </div>
              )}
            </div>
          </Flex>
          {error ? (
            <Result
              status='error'
              title='Error fetching data.'
              extra={
                <Button type='primary' onClick={() => window.location.reload()}>
                  Reload
                </Button>
              }
            />
          ) : tabsLoading ? (
            <Flex
              style={{
                height: "300px",
                marginTop: 35,
                marginBottom: 35,
                borderRadius: 20,
                backgroundColor: "#FFF",
              }}
              align='center'
              justify='center'
            >
              <Spin />
            </Flex>
          ) : (
            <>
              <Flex gap={35} style={{ marginTop: 35, marginBottom: 35 }}>
                {/* dimensions - sidebar */}
                <div
                  style={{
                    background: colorBgContainer,
                    minHeight: 280,
                    padding: "35px 20px 30px 20px",
                    borderRadius: 25,
                    minWidth: 638,
                    alignSelf: "flex-start",
                  }}
                >
                  <div
                    style={{
                      fontSize: "25px",
                      fontWeight: 700,
                      color: "#07224D",
                      marginBottom: 15,
                    }}
                  >
                    Dimensions
                  </div>
                  <DomainsContext.Provider
                    value={{
                      currentDimension,
                      currentDomain,
                      doneDimensionIds,
                    }}
                  >
                    <Flex vertical={true} gap={23}>
                      {domainsData.map((domainData, index) => (
                        <Collapse domainData={domainData} indexCount={index} />
                      ))}
                    </Flex>
                  </DomainsContext.Provider>
                </div>

                {/* main div */}
                <Flex vertical={true} gap={35} style={{ width: "100%" }}>
                  {/* score-card */}
                  {/* <Flex gap={35}>
                    <ScoreCard icon={<Message/>} color='#8051F4' type='domain'/>
                    <ScoreCard icon={<Book/>} color='#EC42B6' type='dimension'/>
                  </Flex> */}

                  {/* questionnaire */}
                  <div
                    style={{
                      backgroundColor: "#FFF",
                      borderRadius: 20,
                      padding: 30,
                      width: "100%",
                    }}
                  >
                    <Flex
                      vertical={true}
                      gap={30}
                      style={{
                        border: "1.5px solid #D7E3F1",
                        borderRadius: 10,
                        padding: "25px 30px 25px 30px",
                      }}
                    >
                      {questionsError ? (
                        <Result
                          status='error'
                          title='Error fetching Questions.'
                          extra={
                            <Button
                              type='primary'
                              onClick={() => window.location.reload()}
                            >
                              Reload
                            </Button>
                          }
                        />
                      ) : questionsLoading ? (
                        <Flex
                          style={{ height: "350px" }}
                          align='center'
                          justify='center'
                        >
                          <Spin
                            indicator={
                              <LoadingOutlined style={{ fontSize: 24 }} spin />
                            }
                          />
                        </Flex>
                      ) : (
                        <>
                          {/* headings */}
                          <Flex vertical={true} gap={15}>
                            <div
                              style={{
                                // font-family: Lato;
                                fontSize: "25px",
                                fontWeight: 700,
                                color: "#07224D",
                                lineHeight: "30px",
                                letterSpacing: "0em",
                              }}
                            >
                              {domainsData[currentDomain.domainIndex]?.title}
                            </div>
                            <div
                              style={{
                                // font-family: Lato;
                                fontSize: "20px",
                                fontWeight: 400,
                                lineHeight: "24px",
                                letterSpacing: "0em",
                                color: "#5B6E84",
                              }}
                            >
                              {
                                currentDimensionsData[
                                  currentDimension.dimensionIndex
                                ]?.title
                              }
                            </div>
                          </Flex>

                          {/* questions */}
                          <Form
                            // wrapperCol={{ span: 16 }}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 30,
                            }}
                            onFinish={
                              showSubmitButton
                                ? submitQuestionnaire
                                : isUpdate
                                  ? updateQuestionsResponse
                                  : sendQuestionsResponse
                            }
                            form={form}
                          >
                            <Flex vertical={true} gap={24}>
                              {questions.map((questionData) => (
                                <GenerateQuestionFields
                                  key={questionData.id}
                                  questionData={questionData}
                                />
                              ))}
                            </Flex>
                            <Form.Item style={{ margin: 0 }}>
                              <Flex gap={20} justify='flex-end'>
                                {!(
                                  currentDomain.domainIndex === 0 &&
                                  currentDimension.dimensionIndex === 0
                                ) && (
                                  <Button
                                    type='default'
                                    htmlType='button'
                                    onClick={handlePrevious}
                                  >
                                    Previous
                                  </Button>
                                )}
                                {isUpdate ? (
                                  <Button
                                    type='primary'
                                    disabled={disableSaveBtn}
                                    htmlType='submit'
                                  >
                                    Update
                                  </Button>
                                ) : (
                                  <Button
                                    type='primary'
                                    disabled={disableSaveBtn}
                                    htmlType='submit'
                                  >
                                    {showSubmitButton
                                      ? "Save & Submit"
                                      : "Save & Next"}
                                  </Button>
                                )}
                                {isUpdate && (
                                  <Button
                                    type='default'
                                    htmlType='button'
                                    onClick={handleNext}
                                  >
                                    Next
                                  </Button>
                                )}
                              </Flex>
                            </Form.Item>
                          </Form>
                        </>
                      )}
                    </Flex>
                  </div>
                </Flex>
              </Flex>
            </>
          )}
          {/* <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 36,
              borderRadius: borderRadiusLG,
              marginTop: 16
            }}
          >
            <Space style={{justifyContent: 'space-between', alignItems: 'flex-start', width: '100%'}}>
              <Typography.Title>
                Questionnaire - {questionnaireName[readinessIndexType]}
              </Typography.Title>
              <Typography.Title level={5}>
                {!companyLoading ? companyData?.companyName && `Company: ${companyData.companyName}` :
                  <div style={{width: '150px', textAlign: 'center'}}><Spin indicator={<LoadingOutlined spin />} /></div>
                }
              </Typography.Title>
            </Space>
            {
              error ? <Result
                status="error"
                title="Error fetching data."
                extra={<Button type="primary" onClick={() => window.location.reload()}>Reload</Button>
                }
              /> : (tabsLoading ?
              <Flex style={{height: '150px'}} align="center" justify="center">
                <Spin/>
              </Flex> :
              <>
                <Steps
                  style={{ marginTop: 48 }}
                  current={currentStep}
                  items={domainsData.map(({ title }, index) => ({ title: `Domain ${index+1}`, description: title }))}
                />
                <Layout
                  style={{
                    marginTop: 48,
                    // border: '1px solid black',
                    padding: '24px 0',
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <Sider
                    style={{
                      background: colorBgContainer,
                    }}
                    width={250}
                  >
                    <Menu
                      mode="inline"
                      selectedKeys={[`${currentDimension.dimensionId}`]}
                      selectable={false}
                      style={{
                        height: '100%',
                        // marginTop: 64,
                      }}
                      items={[
                        {
                          key: 'dimensions',
                          label: 'Dimensions',
                          type: 'group',
                          children: currentDimensionsData.map(({ id, title }) => ({ key: `${id}`, label: title }))
                        }
                      ]}
                    />
                  </Sider>
                  <Content
                    style={{
                      padding: '0 24px',
                      minHeight: 280,
                    }}
                  >
                    {
                      questionsError ? <Result
                        status="error"
                        title="Error fetching Questions."
                        extra={<Button type="primary" onClick={() => window.location.reload()}>Reload</Button>
                        }
                      /> : (questionsLoading ?
                      <Flex style={{height: '350px'}} align="center" justify="center">
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 24, }} spin />}/>
                      </Flex> :
                      <>
                        <Typography.Title style={{marginTop: 0}} level={1}>{domainsData[currentDomain.domainIndex]?.title}</Typography.Title>
                        <Typography.Title style={{marginTop: 0}} level={3}>{currentDimensionsData[currentDimension.dimensionIndex]?.title}:</Typography.Title>

                        <Form wrapperCol={{ span: 16 }} style={{marginTop: 48}}
                          onFinish={showSubmitButton ? submitQuestionnaire : (isUpdate ? updateQuestionsResponse : sendQuestionsResponse)}
                          form={form}
                        >
                          {questions.map((questionData) => <GenerateQuestionFields key={questionData.id} questionData={questionData}/>)}
                          <Form.Item>
                            <Space>
                              {!(currentDomain.domainIndex === 0 && currentDimension.dimensionIndex === 0) &&
                                <Button type='default' htmlType='button' onClick={handlePrevious}>Previous</Button>
                              }
                              {isUpdate ? <Button type='primary' disabled={disableSaveBtn} htmlType='submit'>Update</Button>
                              : <Button type='primary' disabled={disableSaveBtn} htmlType='submit'>{showSubmitButton ? 'Save & Submit' : 'Save & Next'}</Button>}
                              {isUpdate && <Button type='default' htmlType='button' onClick={handleNext}>Next</Button>}
                            </Space>
                          </Form.Item>
                        </Form>
                      </>)
                    }
                  </Content>
                </Layout>
              </>)
            }
          </div> */}
        </Content>
        <Footer />
      </Layout>
    </>
  );
};

export default Questionnaire;
